import React, { useEffect } from "react";
import { graphql } from "gatsby";

import Layout from "../components/common/layout";
import Header from "../components/common/Header";

import SEO from "../components/seo";
import HowItWorksSlider from "../components/howitworks/HowItWorksSlider";
import WebsiteContainer from "../components/common/WebsiteContainer";
import CustomContainer from "../components/common/CustomContainer";
import ScheduleDemoFlag from "../components/common/ScheduleDemoFlag";

const HowItWorks = ({ data }) => {
  const content = JSON.parse(data.contentfulJson.json.json);
  useEffect(() => {
    return function cleanup() {
      localStorage.removeItem("clicked");
      localStorage.removeItem("autoplayCount");
    };
  }, []);

  const items = data.allContentfulHowItWorksChapter.edges.sort(
    (a, b) => a.node.order - b.node.order
  );

  return (
    <Layout>
      <Header headerFixed={true} data={{ contentfulJson: data.headerJson }} />
      <SEO seo={data.contentfulSeo} url="https://trend.io/product-tour" />
      <CustomContainer p="0" pos="relative">
        <HowItWorksSlider items={items} />
        <ScheduleDemoFlag content={content} />
      </CustomContainer>
    </Layout>
  );
};

export const query = graphql`
  query HowItWorksQuery {
    contentfulJson(contentful_id: { eq: "5Vcmlzumysc60fqlND8Gri" }) {
      json {
        json
      }
    }

    headerJson: contentfulJson(
      contentful_id: { eq: "2NCeKxLHd9JagUBAEsXDMo" }
    ) {
      json {
        json
      }
    }

    allContentfulHowItWorksChapter(sort: { fields: [order] }) {
      edges {
        node {
          title
          description
          order
          image {
            file {
              url
            }
            description
          }
          flag {
            flagImage
            flagLink
            flagLinkText
            flagText
          }
          video {
            file {
              url
            }
            description
          }
        }
      }
    }

    contentfulSeo(contentful_id: { eq: "4uL1LDweBtbQH8CYWwTJfo" }) {
      ...SeoFragment
    }
  }
`;

export default HowItWorks;
